export interface IGroupCode {
  groupCode: string
  name: string
  description: string
}

export const GroupCodes: IGroupCode[] = [
  {
    groupCode: 'CO',
    name: 'Contract Obligations',
    description:
      'Use this code when a joint payer/payee contractual agreement or a regulatory requirement resulted in an adjustment.'
  },
  {
    groupCode: 'OA',
    name: 'Other adjustments',
    description: `Avoid using the Other Adjustment Group Code (OA) except for business
  situations described in sections 1.10.2.6, 1.10.2.7, and 1.10.2.13.`
  },
  {
    groupCode: 'PI',
    name: 'Payor Initiated Reductions',
    description: `Use this code when, in the opinion of the payer, the adjustment is not the responsibility of the patient, but there
  is no support contract between the provider and payer (i.e. medical review or professional review organization adjustments).`
  },
  {
    groupCode: 'PR',
    name: 'Patient Responsibility',
    description: ''
  }
]
